angular.module('controllers').controller('additionalPrinterController', ['$scope', '$rootScope', '$controller', '$http', 'Crud', '$mdDialog', '$route', '$routeParams', '$location',
	function ($scope, $rootScope, $controller, $http, Crud, $mdDialog, $route, $routeParams, $location) {
		$rootScope.path = '/additional-printer';
		$scope.path = $rootScope.path;
		$rootScope.modelName = 'additional-printer';
		$scope.pathTemplate = 'food/additionalprinters';
		$scope.title = 'Imprimante';

		angular.extend(this, $controller('crudController', {$scope: $scope}));

		$scope.sortType = 'additional_printer_ip';
		$scope.defaultItem = 10;
        $rootScope.typeId = 'id';
		$scope.search.order = 'asc';
		$scope.classAction = 'td-big';
		$scope.columns = {
			//'id':{'label':'Detalii', 'filter':0, 'filterType':'input'},
			'additional_printer_ip':{'label':'Ip imprimanta', 'filter':1, 'filterType':'input'},
			'additional_printer_name':{'label':'Nume', 'filter':1, 'filterType':'input'},
			'kitchen_name':{'label':'Bucatarie', 'filter':1, 'filterType':'input'},
			'status':{'label':'Status', 'filter':1, 'filterType':'select'}
		};

		$scope.columns.status.options = [
			{'id':'', 'value' : ''},
			{'id':1, 'value' : 'true'},
			{'id':0, 'value' : 'false'}
		];

		/* get dependent fields */
		$scope.getDependedFields = function () {
			Crud.getDependedFields($scope.path)
				.success(function (data) {
					$scope.additionals['kitchens'] = data.kitchens;
					/*$scope.columns.car_no.options = [{id:'', value:''}];
					angular.forEach(data.cars, function (item, key) {
						$scope.columns.car_no.options.push({id:item.car_no, value:item.car_no +' ('+item.car_mark+')'});
					});*/
				});
		}

		$scope.additionals['content_type'] = 'form-urlencoded';
        $scope.additionals['columnDisplay'] = 'additional_printer_ip';

		$scope.additionals['searchTerm'];
		$scope.additionals['clearSearchTerm'] = function() {
			$scope.additionals['searchTerm'] = '';
		};
		$scope.additionals['onSearchChange'] = function(ev) {
			ev.stopPropagation();
		};

		$scope.additionals['getFoodCategories']= function() {
			Crud.get($scope.path + '/getFoodCategories')
				.success(function (data) {
					$scope.additionals['food_categories'] = data.foodCategories;
				});
		}

		/* assign products/categories*/
		$scope.assignProductModel = function (ev, path, model) {
			$scope.additionals['food_products'] = [];
			$scope.additionals['getFoodCategories']();
			$scope.additionals['additional_printer_ip'] = model['additional_printer_ip'];

			if($scope.mode_action == 'page') {
				$scope.controlSH = true;
				$scope.action = 'assignproduct';
				angular.element(document.querySelector('.fill-height')).animate({ scrollTop: 250 }, "slow");

				$scope.additionals['invalid'] = '';

				var currentModel = {};
				$scope.modelData = currentModel;

				$scope.cancel = function () {
					$scope.modelData = {};
					$scope.errors = {};
					$scope.controlSH = false;
				};

				if (!angular.isUndefined($scope.additionals['function'])) {
					$scope.additionals['function'](ev, $scope.modelData);
				}

				$scope.additionals['checkProducts'] = function (value, food_category_id, food_product_id) {
					if(value != true) {
						$scope.modelData.check_all_products = false;
					}
					if(value == true) {
						if (angular.isUndefined($scope.checkedProd) || $scope.checkedProd == 'undefined') {
							$scope.checkedProd = {};
						}
						if (angular.isUndefined($scope.checkedProd[food_product_id]) || $scope.checkedProd[food_product_id] == 'undefined') {
							$scope.checkedProd[food_product_id] = {};
						}

						$scope.checkedProd[food_product_id] = food_product_id.toString();
						if (!angular.isUndefined($scope.modelData.categories[food_category_id]) && $scope.modelData.categories[food_category_id] != 'undefined') {

							if (Object.keys($scope.checkedProd).length == Object.keys($scope.modelData.categories[food_category_id].products).length) {
								$scope.modelData.check_all_products = true;
							}
						}

					}
				}

				$scope.additionals['checkAllProducts'] = function (food_category_id) {
					angular.forEach($scope.additionals['food_products'], function (item, key) {
						if (angular.isUndefined($scope.modelData.categories) || $scope.modelData.categories == 'undefined') {
							$scope.modelData.categories = {};
						}
						if (angular.isUndefined($scope.modelData.categories[food_category_id]) || $scope.modelData.categories[food_category_id] == 'undefined') {
							$scope.modelData.categories[food_category_id] = {};
						}
						if (angular.isUndefined($scope.modelData.categories[food_category_id].products) || $scope.modelData.categories[food_category_id].products == 'undefined') {
							$scope.modelData.categories[food_category_id].products = {};
						}
						if (angular.isUndefined($scope.modelData.categories[food_category_id].products[item['food_product_id']]) || $scope.modelData.categories[food_category_id].products[item['food_product_id']] == 'undefined') {
							$scope.modelData.categories[food_category_id].products[item['food_product_id']] = {};
						}
						if($scope.modelData.check_all_products == true) {
							$scope.modelData.categories[food_category_id].products[item['food_product_id']]['selected'] = true;
						} else {
							$scope.modelData.categories[food_category_id].products[item['food_product_id']]['selected'] = false;
						}
					});
				}

				$scope.additionals['getFoodProductsByCategory'] = function (food_category_id) {
					$scope.modelData.check_all_products = false;
					$scope.checkedProd = {};

					Crud.get(path+'/getFoodProductsByCategory?additional_printer_id='+model.id+'&food_category_id='+food_category_id)
						.success(function (data) {
							$scope.additionals['food_products'] = data.foodProducts;
							angular.forEach(data.foodProducts, function (item, key) {
								if (angular.isUndefined($scope.checkedProd) || $scope.checkedProd == 'undefined') {
									$scope.checkedProd = {};
								}
								if (angular.isUndefined($scope.checkedProd[item['food_product_id']]) || $scope.checkedProd[item['food_product_id']] == 'undefined') {
									$scope.checkedProd[item['food_product_id']] = {};
								}
								$scope.checkedProd[item['food_product_id']] = item['food_product_id'].toString();

								if(item['additional_printer_id'] == model.id) {
									if (angular.isUndefined($scope.modelData.categories) || $scope.modelData.categories == 'undefined') {
										$scope.modelData.categories = {};
									}
									if (angular.isUndefined($scope.modelData.categories[food_category_id]) || $scope.modelData.categories[food_category_id] == 'undefined') {
										$scope.modelData.categories[food_category_id] = {};
									}
									if (angular.isUndefined($scope.modelData.categories[food_category_id].products) || $scope.modelData.categories[food_category_id].products == 'undefined') {
										$scope.modelData.categories[food_category_id].products = {};
									}
									if (angular.isUndefined($scope.modelData.categories[food_category_id].products[item['food_product_id']]) || $scope.modelData.categories[food_category_id].products[item['food_product_id']] == 'undefined') {
										$scope.modelData.categories[food_category_id].products[item['food_product_id']] = {};
									}
									$scope.modelData.categories[food_category_id].products[item['food_product_id']]['selected'] = true;

								}
							});

							if (!angular.isUndefined($scope.modelData.categories) && $scope.modelData.categories != 'undefined') {
								if (!angular.isUndefined($scope.modelData.categories[food_category_id]) && $scope.modelData.categories[food_category_id] != 'undefined') {
									if (data.foodProducts.length == Object.keys($scope.modelData.categories[food_category_id].products).length) {
										$scope.modelData.check_all_products = true;
									}
								}
							}

						});

				}

				$scope.assignProduct = function () {
					$scope.additionals['buttonDisabled'] = true;
					if (!angular.isUndefined($scope.additionals['internFunction'])) {
						$scope.additionals['internFunction'](ev, $scope.modelData);
					}
					$scope.isLoading = true;
					var post = {};
					post['additional_printer_id'] = model.id;
					post['categories'] = $scope.modelData['categories'];
					post['route'] = 'assignproduct';
					post['products'] = {};
					var no = 0;

					Crud.post($scope.additionals['content_type'], post, path+'/assignProduct')
						.success(function (data) {
							if (!angular.isUndefined(data.invalid)) {
								$scope.additionals['invalid'] = data.invalid;
							} else {
								if (!angular.isUndefined($scope.additionals['functionResult'])) {
									$scope.additionals['functionResult'](ev, data);
								}
								/*if (!angular.isUndefined($scope.selected[model[$rootScope.typeId]])) {
								 $scope.selected[model[$rootScope.typeId]] = model;
								 }*/
								if (!angular.isUndefined(data.currentModel)) {
									if (!angular.isUndefined($scope.models)) {
										$scope.getElement($scope.models, data.currentModel);
									}
									if (!angular.isUndefined($scope.modelData)) {
										$scope.modelData = data.currentModel;
									}
								} else {
									if (!angular.isUndefined($scope.models)) {
										$scope.getElement($scope.models, currentModel);
									}
									if (!angular.isUndefined($scope.modelData)) {
										$scope.modelData = currentModel;
									}
								}
							}
							$scope.modelData = {};
							$scope.errors = {};
							$scope.isLoading = false;
							$scope.controlSH = false;
							$scope.additionals['buttonDisabled'] = false;
						})
						.error(function (data) {
							$scope.isLoading = false;
							$scope.errors = data.errors;
							$scope.additionals['buttonDisabled'] = false;
						});
				};
			}

			if($scope.mode_action == 'dialog') {

				$scope.additionals['invalid'] = '';
				var currentModel = {};

				$mdDialog.show({
					controller: DialogController,
					templateUrl: 'assignProductDialog.tmpl.html',
					parent: angular.element(document.body),
					targetEvent: ev,
					clickOutsideToClose: true,
					locals: {
						pathTemplate: $scope.pathTemplate,
						model: currentModel,
						selected: $scope.selected,
						additionals: $scope.additionals,
						additional_printerId: model.id,
						path: $scope.path
					}
				}).then(function () {

				});
				DialogController.$inject = ['$scope', '$mdDialog', 'pathTemplate', 'model', 'selected', 'additionals', 'additional_printerId', 'path'];
				function DialogController($scope, $mdDialog, pathTemplate, model, selected, additionals, additional_printerId, path) {
					$scope.pathTemplate = pathTemplate;
					$scope.modelData = model;
					$scope.additionals = additionals;
					$scope.selected = selected;
					$scope.path = path;

					$scope.cancel = function () {
						$mdDialog.cancel();
					};

					if (!angular.isUndefined($scope.additionals['function'])) {
						$scope.additionals['function'](ev, $scope.modelData);
					}

					$scope.additionals['checkProducts'] = function (value, food_category_id, food_product_id) {
						if(value != true) {
							$scope.modelData.check_all_products = false;
						}
						if(value == true) {
							if (angular.isUndefined($scope.checkedProd) || $scope.checkedProd == 'undefined') {
								$scope.checkedProd = {};
							}
							if (angular.isUndefined($scope.checkedProd[food_product_id]) || $scope.checkedProd[food_product_id] == 'undefined') {
								$scope.checkedProd[food_product_id] = {};
							}

							$scope.checkedProd[food_product_id] = food_product_id.toString();
							if (!angular.isUndefined($scope.modelData.categories[food_category_id]) && $scope.modelData.categories[food_category_id] != 'undefined') {

								if (Object.keys($scope.checkedProd).length == Object.keys($scope.modelData.categories[food_category_id].products).length) {
									$scope.modelData.check_all_products = true;
								}
							}

						}
					}

					$scope.additionals['checkAllProducts'] = function (food_category_id) {
						angular.forEach($scope.additionals['food_products'], function (item, key) {
							if (angular.isUndefined($scope.modelData.categories) || $scope.modelData.categories == 'undefined') {
								$scope.modelData.categories = {};
							}
							if (angular.isUndefined($scope.modelData.categories[food_category_id]) || $scope.modelData.categories[food_category_id] == 'undefined') {
								$scope.modelData.categories[food_category_id] = {};
							}
							if (angular.isUndefined($scope.modelData.categories[food_category_id].products) || $scope.modelData.categories[food_category_id].products == 'undefined') {
								$scope.modelData.categories[food_category_id].products = {};
							}
							if (angular.isUndefined($scope.modelData.categories[food_category_id].products[item['food_product_id']]) || $scope.modelData.categories[food_category_id].products[item['food_product_id']] == 'undefined') {
								$scope.modelData.categories[food_category_id].products[item['food_product_id']] = {};
							}
							if($scope.modelData.check_all_products == true) {
								$scope.modelData.categories[food_category_id].products[item['food_product_id']]['selected'] = true;
							} else {
								$scope.modelData.categories[food_category_id].products[item['food_product_id']]['selected'] = false;
							}
						});
					}

					$scope.additionals['getFoodProductsByCategory'] = function (food_category_id) {
						$scope.modelData.check_all_products = false;
						$scope.checkedProd = {};

						Crud.get($scope.path+'/getFoodProductsByCategory?additional_printer_id='+additional_printerId+'&food_category_id='+food_category_id)
							.success(function (data) {
								$scope.additionals['food_products'] = data.foodProducts;
								angular.forEach(data.foodProducts, function (item, key) {
									if (angular.isUndefined($scope.checkedProd) || $scope.checkedProd == 'undefined') {
										$scope.checkedProd = {};
									}
									if (angular.isUndefined($scope.checkedProd[item['food_product_id']]) || $scope.checkedProd[item['food_product_id']] == 'undefined') {
										$scope.checkedProd[item['food_product_id']] = {};
									}
									$scope.checkedProd[item['food_product_id']] = item['food_product_id'].toString();

									if(item['additional_printer_id'] == additional_printerId) {
										if (angular.isUndefined($scope.modelData.categories) || $scope.modelData.categories == 'undefined') {
											$scope.modelData.categories = {};
										}
										if (angular.isUndefined($scope.modelData.categories[food_category_id]) || $scope.modelData.categories[food_category_id] == 'undefined') {
											$scope.modelData.categories[food_category_id] = {};
										}
										if (angular.isUndefined($scope.modelData.categories[food_category_id].products) || $scope.modelData.categories[food_category_id].products == 'undefined') {
											$scope.modelData.categories[food_category_id].products = {};
										}
										if (angular.isUndefined($scope.modelData.categories[food_category_id].products[item['food_product_id']]) || $scope.modelData.categories[food_category_id].products[item['food_product_id']] == 'undefined') {
											$scope.modelData.categories[food_category_id].products[item['food_product_id']] = {};
										}
										$scope.modelData.categories[food_category_id].products[item['food_product_id']]['selected'] = true;

									}
								});

								if (!angular.isUndefined($scope.modelData.categories) && $scope.modelData.categories != 'undefined') {
									if (!angular.isUndefined($scope.modelData.categories[food_category_id]) && $scope.modelData.categories[food_category_id] != 'undefined') {
										if (data.foodProducts.length == Object.keys($scope.modelData.categories[food_category_id].products).length) {
											$scope.modelData.check_all_products = true;
										}
									}
								}

							});

					}

					$scope.assignProduct = function () {
						$scope.additionals['buttonDisabled'] = true;
						if (!angular.isUndefined($scope.additionals['internFunction'])) {
							$scope.additionals['internFunction'](ev, $scope.modelData);
						}
						$scope.isLoading = true;
						var post = {};
						post['additional_printer_id'] = additional_printerId;
						post['categories'] = $scope.modelData['categories'];
						post['route'] = 'assignproduct';
						post['products'] = {};
						var no = 0;

						Crud.post($scope.additionals['content_type'], post, $scope.path+'/assignProduct')
							.success(function (data) {
								if (!angular.isUndefined(data.invalid)) {
									$scope.additionals['invalid'] = data.invalid;
								} else {
									if (!angular.isUndefined($scope.additionals['functionResult'])) {
										$scope.additionals['functionResult'](ev, data);
									}
									/*if (!angular.isUndefined($scope.selected[model[$rootScope.typeId]])) {
                                     $scope.selected[model[$rootScope.typeId]] = model;
                                     }*/
									if (!angular.isUndefined(data.currentModel)) {
										if (!angular.isUndefined($scope.models)) {
											$scope.getElement($scope.models, data.currentModel);
										}
										if (!angular.isUndefined($scope.modelData)) {
											$scope.modelData = data.currentModel;
										}
									} else {
										if (!angular.isUndefined($scope.models)) {
											$scope.getElement($scope.models, currentModel);
										}
										if (!angular.isUndefined($scope.modelData)) {
											$scope.modelData = currentModel;
										}
									}
								}
								$scope.modelData = {};
								$scope.errors = {};
								$scope.isLoading = false;
								$scope.controlSH = false;
								$scope.additionals['buttonDisabled'] = false;
								$mdDialog.hide();

							})
							.error(function (data) {
								$scope.isLoading = false;
								$scope.errors = data.errors;
								$scope.additionals['buttonDisabled'] = false;
							});
					};

				}
			}

		};
		/* end assign products/categories*/
	}]
)
